import React from 'react';
import ComingSoonUI from "./ComingSoon.ui";

import {TComingSoon} from "./ComingSoon.types";

export const ComingSoon: TComingSoon = () => {
    return <ComingSoonUI />
};